// extracted by mini-css-extract-plugin
export default {"games_section_headline":"notification_games_section_headline__gKeY0","games_section_title":"notification_games_section_title__fYsO6"};